'use strict';


/*

A queue of functions

Each function gets passed a next function to continue the queue, plus the rest of the arguments passed to execute

Some exmaples:

//Simplest possible queue with 2 functions

var simpleFQ = FunctionQueue(
	function(next,foo){
		//console.log('one');
		next();
	},
	function(next,foo){
		//console.log('two');
		next();
	}
);

//run it passing ['tom','dick','harry'] to each function
//be careful to freeze any object reference parameters that the functions should not modify to avoid side effects

function finishedSimpleFQ(foo){
	//console.log('finished',arguments);
}

simpleFQ.execute(finishedSimpleFQ, [tom','dick','harry']);

//A queue which waits for some event. Can be extended to wait for almost anything

var eventFQ = FunctionQueue(
	function(next,foo){
		var e = document.getElementById('foo');

		function onClick(){
			//have to remove this to ensure it only runs once
			e.removeEventListener(onClick);
			next();
		}

		e = document.getElementById('foo');
		e.addEventListener('click',onClick);
	}
);

//in this case do nothing when the queue finishes
eventFQ.execute(function(){}, [tom','dick','harry']);

//A queue that nests simpleFQ and eventFQ. Everything in simpleFQ will run first, then eventFQ then finally allDone

var nestingFQ = FunctionQueue(
	simpleFQ.execute,
	eventFQ.execute
);

function allFinished(){
	//console.log('All finished');
}

nestingFQ.execute(allFinished, [tom','dick','harry']);

*/

/**
 * @module bootstrap/FunctionQUeue
 * @memberof kernel
 * @description Helper module to queuing/sequencing and executing functions
 */
//define(function(){

	export default function FunctionQueue(){

		var Q = Array.prototype.slice.call(arguments,0);

		function execute(next){

			var q = Q.slice(0);
			var a = Array.prototype.slice.call(arguments,0);
			//if called using qInstance.execute(a,b,c,..) this is bound to the queue
			/*jshint validthis:true */
			var bound = this;

			function continueFunctionQueue(){
				var h = q.shift();
				if(h){
                    if (arguments.length>0) { //Fix an issue when jumping between state flows where a becomes two parameters
						h.apply(bound, Array.prototype.concat(a, arguments[0])); //Pass arguments to next call?
					} else {
						h.apply(bound, a);
					}
				}
			}

			q.push(next); //append the final function to the end of the queue
			a[0] = continueFunctionQueue;     //make f the first parameter of each call made from f
			continueFunctionQueue();          //start the queue
		}

		/**
		 * @function unshift
		 * @private
		 * @description add method to the front of the queue
		 * @param f {function} The function to be added to the queue
		 */
		function unshift(f){
			Q.unshift(f);
		}

		/**
		 * @function push
		 * @private
		 * @description add method to the end of the queue
		 * @param f {function} The function to be added to the queue
		 */
		function push(f){
			Q.push(f);
		}

		return Object.freeze({
			execute:execute,
			unshift:unshift,
			push:push
		});
	}

//});
